import _ from 'lodash';
import { DOSSIER_TYPES, DOSSIER_TYPE_OPTIONS } from './settings.constants';

const TEMPLATE_CATEGORIES_SUFFIXES = {
  REQUEST: 'aanvraag',
  CLARIFICATION: 'vraagverheldering',
  CASETABLE_PREPARATION: 'casetafel',
  CASETABLE_REPORT: 'terugkoppeling_casetafel',
  COMMISSION_PREPARATION: 'commissie',
  COMMISSION_REPORT: 'advies_commissie',
  PROCEDURE: 'opvolging',
  PROCEDURE_COMPONENTS: 'opvolging_onderdelen',
  CONTACTMOMENT: 'contactmoment'
};
const TEMPLATE_CATEGORIES_SUFFIXES_LABELS = {
  [TEMPLATE_CATEGORIES_SUFFIXES.REQUEST]: 'Aanvraag',
  [TEMPLATE_CATEGORIES_SUFFIXES.CLARIFICATION]: 'Vraagverheldering',
  [TEMPLATE_CATEGORIES_SUFFIXES.CASETABLE_PREPARATION]: 'Casetafel',
  [TEMPLATE_CATEGORIES_SUFFIXES.CASETABLE_REPORT]: 'Terugkoppeling casetafel',
  [TEMPLATE_CATEGORIES_SUFFIXES.COMMISSION_PREPARATION]: 'Commissie',
  [TEMPLATE_CATEGORIES_SUFFIXES.COMMISSION_REPORT]: 'Advies commissie',
  [TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE]: 'Opvolging',
  [TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE_COMPONENTS]: 'Opvolging onderdelen',
  [TEMPLATE_CATEGORIES_SUFFIXES.CONTACTMOMENT]: 'Contactmoment'
};

const TEMPLATE_CATEGORIES_OPTIONS = _.flatten([
  ...DOSSIER_TYPE_OPTIONS.filter((type) => type.value === DOSSIER_TYPES.PROGRAM).map(({ value, label }) => [
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.REQUEST}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.REQUEST]}`
    },
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.CLARIFICATION}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.CLARIFICATION]}`
    },
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.CASETABLE_PREPARATION}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.CASETABLE_PREPARATION]}`
    },
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.CASETABLE_REPORT}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.CASETABLE_REPORT]}`
    },
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE]}`
    },
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE_COMPONENTS}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE_COMPONENTS]}`
    },
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.CONTACTMOMENT}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.CONTACTMOMENT]}`
    }
  ]),
  ...DOSSIER_TYPE_OPTIONS.filter((type) => type.value === DOSSIER_TYPES.FINANCED_PROGRAM).map(({ value, label }) => [
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.REQUEST}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.REQUEST]}`
    },
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.COMMISSION_PREPARATION}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.COMMISSION_PREPARATION]}`
    },
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.COMMISSION_REPORT}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.COMMISSION_REPORT]}`
    },
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE]}`
    },
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE_COMPONENTS}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE_COMPONENTS]}`
    },
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.CONTACTMOMENT}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.CONTACTMOMENT]}`
    }
  ]),
  ...DOSSIER_TYPE_OPTIONS.filter((type) => type.value === DOSSIER_TYPES.ACTION).map(({ value, label }) => [
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.REQUEST}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.REQUEST]}`
    },
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE]}`
    },
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE_COMPONENTS}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE_COMPONENTS]}`
    },
    {
      value: `${value}_${TEMPLATE_CATEGORIES_SUFFIXES.CONTACTMOMENT}`,
      label: `${label} - ${TEMPLATE_CATEGORIES_SUFFIXES_LABELS[TEMPLATE_CATEGORIES_SUFFIXES.CONTACTMOMENT]}`
    }
  ])
]);

export { TEMPLATE_CATEGORIES_SUFFIXES, TEMPLATE_CATEGORIES_OPTIONS };
